import {
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Button,
  Col,
  Row
} from "reactstrap";
import TextEditor from "components/editor/TextEditor";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useParams,useNavigate } from "react-router-dom"
import { httpRequest } from "utils/httpRequest";
import { toast } from "react-toastify"
import {useState} from "react"

const AddSubChapter = () => {


    const[buttonLoading,setButtonLoading]=useState(false)


  const { id: chapterId } = useParams()
  const navigate=useNavigate()


  // Formik validation schema
  const validationSchema = Yup.object().shape({
    title: Yup.string()
      .required("Chapter title is required")
      .min(3, "Title must be at least 3 characters"),
    description: Yup.string()
      .required("Chapter description is required")

  });

  const formik = useFormik({
    initialValues: {
      title: "",
      description: ""
    },
    validationSchema,
    onSubmit: async (values) => {
      formik.setTouched({

        title: true,
        description: true
      });

      const errors = await formik.validateForm();

      if (Object.keys(errors).length > 0) return false;
      setButtonLoading(true)
      try {


        const response = await httpRequest(
          "chapter/add",
          "POST",
          {
            parentId: chapterId,
            title: values?.title,
            content: values?.description,
            chapterId: null


          },
          {},
          true,
          true
        );
        if (response?.code === 200) {
        
          toast.success("Sub chapter added successfully.")
          formik.resetForm({
            values: {
              title: "",
              description: ""
            }
          })
          navigate(-1)
        }

      } catch (error) {
        console.log(error);
        
      }finally{
        setButtonLoading(false)
      }
    }
  });

  return (
    <Row className="mt-4 justify-content-center">
      <Col lg="8" md="8" className="mx-auto mt-4">
        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent pb-3">
            <div className="text-muted text-center mt-2 mb-3">
              <small>Add Sub Chapter</small>
            </div>
          </CardHeader>
          <CardBody className="px-lg-5 py-lg-4">
            <Form onSubmit={formik.handleSubmit}>
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-book-bookmark" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Chapter Title"
                    type="text"
                    name="title"
                    value={formik.values.title}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </InputGroup>
                {formik.touched.title && formik.errors.title && (
                  <div className="text-danger small mt-1">
                    {formik.errors.title}
                  </div>
                )}
              </FormGroup>

              <FormGroup>
                <label className="form-control-label">Chapter Description</label>
                <TextEditor
                  value={formik.values.description}
                  onChange={(html) =>
                    formik.setFieldValue("description", html)
                  }
                  onBlur={() => formik.setFieldTouched("description", true)}
                  placeholder="Write the chapter description..."
                  hideImageAndLink={true}
                />
                {formik.touched.description && formik.errors.description && (
                  <div className="text-danger small mt-1">
                    {formik.errors.description}
                  </div>
                )}
              </FormGroup>

              <div className="text-center d-flex align-items-center justify-content-center">
                <Button className="mb-3 d-flex align-items-center justify-content-center" color="primary" type="submit" disabled={buttonLoading}>
                  {buttonLoading ? <span className="button-loader"></span> : "Save Chapter"}
                </Button>

              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default AddSubChapter;